import * as React from 'react';
import * as THREE from 'three';
import { TessellateModifier } from 'three-stdlib';

function useTessellation(passes = 3, maxEdgeLength) {
  const ref = React.useRef();
  const original = React.useRef();
  const modifier = React.useRef();
  React.useEffect(() => {
    if (!original.current) {
      original.current = ref.current.geometry.clone();
      modifier.current = new TessellateModifier(parseInt(maxEdgeLength), passes);
    }
  }, [maxEdgeLength, passes]);
  React.useEffect(() => {
    modifier.current.maxEdgeLength = maxEdgeLength;
  }, [maxEdgeLength]);
  React.useEffect(() => {
    if (original.current && ref.current) {
      let geometry = new THREE.BufferGeometry();
      geometry = original.current.clone();
      geometry = modifier.current.modify(geometry);
      ref.current.geometry = geometry;
    }
  }, [maxEdgeLength, passes]);
  return ref;
}

export { useTessellation };
